export default __webpack_public_path__ + "static/landing-video-bfae703c8f2e280dbd6af0aa6e4bc388.mp4";